export default "__VITE_ASSET__Dl0O$uv8__"